import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { IModalComponent, IModalData } from '@app/interfaces';
import { PartnerLink } from '../../../interfaces/partner-links.interface';
import { PartnerService } from '../../../services/partner.service';
import { WrapToasterService } from '@app/services/wrap-toaster-service';

export interface ILinkDeleteOptions {
	link: PartnerLink;
}

@Component({
	selector: 'app-confirm-link-delete',
	templateUrl: './partner-confirm-link-delete-modal.component.html',
	styleUrls: ['./partner-confirm-link-delete-modal.component.scss'],
})
export class PartnerConfirmLinkDeleteModalComponent implements IModalComponent<ILinkDeleteOptions>, OnInit {
	@Input() data: IModalData<ILinkDeleteOptions>;
	link: PartnerLink;
	isLoading$ = new BehaviorSubject<boolean>(false);

	constructor(private partnerService: PartnerService, private toastService: WrapToasterService) {}

	ngOnInit() {
		this.link = this.data.options.link;
	}

	closeEvent(e?: {}): void {}

	confirmDelete() {
		this.isLoading$.next(true);

		this.partnerService.deleteLink(this.link.uuid).subscribe((resp) => {
			if (resp.Success) {
				this.isLoading$.next(false);
				this.toastService.showToast('success', 'Success', `Link successfully deleted.`);
				this.closeEvent({ message: 'linkDeleted' });
			}
		});
	}
}
